import React from 'react';
import { baseURL } from 'config/api.js';
import { useState } from 'react';
//import styles from './companiesNew.module.css';
import { AuthContext } from '../../context/AuthContext.jsx';
import { useContext } from 'react';
import Layout from 'components/global/Layout';
import { toast } from 'react-toastify';
import { ClipLoader } from 'react-spinners';

export const CompaniesNew = () => {
  const [message, setMessage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { userData } = useContext(AuthContext);

  async function sendAPIRequest(payload) {
    let url = baseURL + "/companies/create";
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + userData.token
    };
    const response = await fetch(url, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(payload),
    });
    const jsonData = await response.json();

    if (jsonData.success) {
      toast.success(jsonData.data.message);
      setMessage(jsonData.data.message);
      return Promise.resolve("success");
    }
    else {
      toast.error(jsonData.data.message);
      setMessage(jsonData.data.message);
      return Promise.reject("failure");
    }
  }

  async function handleCreateCompanyForm(event) {
    event.preventDefault();

    setIsSubmitting(true);

    let createCompanyForm = event.target;
    let payload = {}; //empty object
    let companyName = createCompanyForm.elements.namedItem("company_name").value;
    payload.company_name = companyName;
    try {
      await sendAPIRequest(payload);
      setIsSubmitting(false);
    }
    catch (error) {
      setIsSubmitting(false);
    }
  }

  console.log("Before CompaniesNew() rendering");

  return (
    <Layout>
      <div className='w-full space-y-5'>
        <div className='flex flex-row justify-between items-center px-3'>
          <h2 className='text-2xl text-primary font-bold'>Create a new company</h2>
        </div>
        <div className='flex flex-row justify-start'>
          <div>
            {message && message}
          </div>
        </div>
        <div className='flex flex-col  py-3 px-4 border border-[#2F80ED] rounded-lg'>
          <form id="createCompanyForm" onSubmit={handleCreateCompanyForm}>

            <div className='flex flex-col space-y-3 w-full md:w-2/5'>
              <label className='text-base font-normal text-left'>
                Company Name <span className='required'>*</span>
              </label>
              <input type="text" name="company_name" placeholder='Company Name' className='border border-[#8E8EA1] w-full md:w-11/12 py-2 rounded-[40px] px-3 outline-none text-sm' />
            </div>

            <div className='flex flex-row justify-start my-5'>
              <button
                disabled={isSubmitting}
                type="submit"
                className='text-white bg-primary rounded-[40px] w-[299px] h-9'
              >
                {isSubmitting ? <ClipLoader size={17} color="#fff" /> : "Submit"}
              </button>
            </div>

          </form>
        </div>
      </div>
    </Layout>
  )
}
